import { API_BASE_URL } from 'lib/api/utils';
import $fetch from 'lib/fetch';
import { z } from 'zod';
import { GenerateFinanceReportParams } from './reports.requests.types';

const BASE_SERVICE_URL = `${API_BASE_URL}/reports` as const;

export async function generateFinanceReport(
  params: GenerateFinanceReportParams
) {
  const { activationDate = '' } = params;
  const response = await $fetch(
    `${BASE_SERVICE_URL}/financial-report/${activationDate}`,
    {
      responseType: 'text',
    }
  );

  const parsedCsvString = z.string().parse(response.data);
  const contentDisposition = response.originalResponse.headers.get(
    'content-disposition'
  );

  const fileName = contentDisposition?.split('filename=')[1];

  const data = {
    fileName,
    data: parsedCsvString,
  };

  return data;
}
